<template>
  <view class="tw-layout">
    <view class="header" v-if="showHeader">
      <view class="title" v-if="isApp" :style="{ paddingTop: `${statusBarHeight}rpx` }">
        <TwCircleBack
          v-if="isShowBack"
          class="icon-back"
          :style="{ top: `${statusBarHeight + 12}rpx` }"
          @back="onBackClick"
        />
        <text class="over-ellipsis name">{{ title || $store.getters['common/appName'] }}</text>
      </view>
      <slot name="subHeader"></slot>
    </view>
    <view
      :class="['container', isNoPadding ? 'no-padding' : '']"
      :style="{ paddingTop: `${titleHeight + statusBarHeight + subHeaderHeight + (isNoPadding ? 0 : 20)}rpx` }"
    >
      <myloading></myloading>
      <slot></slot>
    </view>
  </view>
</template>
<script>
import TwCircleBack from '@/componentsV3/common/tw-circle-back/index.vue';

const TITLE_HEIGHT = 88;

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subHeaderHeight: {
      type: Number,
      default: 0,
    },
    showOnlineService: {
      type: Boolean,
      default: true,
    },
    orderNo: {
      type: String,
      default: '',
    },
    orderStatus: {
      type: String,
      default: '',
    },
    isShowBack: {
      type: Boolean,
      default: true,
    },
    isNoPadding: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isApp: false,
      statusBarHeight: 0,
    };
  },
  watch: {
    title: {
      handler() {
        this.$app.SetBarTitle(this.title);
      },
      immediate: true,
    },
  },
  created() {
    // #ifdef APP
    this.isApp = true;
    // #endif
    this.getStatusBarHeight();
  },
  components: {
    TwCircleBack,
  },
  computed: {
    titleHeight() {
      return this.isApp ? TITLE_HEIGHT : 0;
    },
  },
  methods: {
    onBackClick() {
      uni.navigateBack();
    },
    getStatusBarHeight() {
      uni.getSystemInfo({
        success: (res) => {
          const statusBarHeight = res.statusBarHeight;
          this.statusBarHeight = statusBarHeight > 0 ? statusBarHeight + 30 : 0;
        },
      });
    },
  },
};
</script>
<style scoped lang="less" scoped>
.tw-layout {
  background-color: #ededed;
  min-height: 100vh;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  .title {
    text-align: center;
    height: 88rpx;
    line-height: 88rpx;
    box-sizing: initial;

    .name {
      display: inline-block;
      font-size: 32rpx;
      font-weight: 500;
      color: #141414;
      max-width: calc(100% - 200rpx);
    }
    .icon-back {
      position: absolute;
      left: 20rpx;
    }
  }
}
.container {
  padding: 0 20rpx 20rpx;
  &.no-padding {
    padding: 0;
  }
}
.kf-icon {
  width: 60rpx;
  height: 60rpx;
}
</style>
